module.exports = __webpack_public_path__ + "img/catchcopy-sp-2.7775a8be.png";